/* eslint-disable no-unused-vars */
/* eslint-disable no-alert */
import {
  Box,
  Button,
  Grid,
  IconButton,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CancelIcon from "@mui/icons-material/Close";

import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { number, object, string } from "yup";

import { useStateContext } from "contexts/ContextProvider";
import useAxiosPrivate from "contexts/interceptors/axios";

const style = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  position: "absolute",
  backgroundColor: "#e9e9e9",
  // background: "linear-gradient(40deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8))",
  //   border: "solid 2px #46e3be",
  boxShadow: "3px 2px 20px 3px rgba(0, 0, 0, 0.4)",
  borderRadius: "10px",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  p: 2,
  overflow: "auto",
  "@media (min-width: 10px)": {
    height: "90vh",
    width: "85vw",
  },

  "@media (min-width: 480px)": {
    height: "85vh",
    width: "80vw",
  },

  "@media (min-width: 640px)": {
    height: "75vh",
    width: "70vw",
  },

  "@media (min-width: 768px)": {
    height: "75vh",
    width: "70vw",
  },

  "@media (min-width: 1024px)": {
    height: "80vh",
    width: "70vw",
  },

  "@media (min-width: 1082px)": {
    height: "80vh",
    width: "65vw",
  },
};

export default function SubmitFormModal({
  open,
  handleClose,
  data,
  onSubmitSuccess,
  submissionStatus,
}) {
  const { auth } = useStateContext();
  const axiosPrivate = useAxiosPrivate();

  const [file, setFile] = useState();
  const [disabled, setDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const isResubmission = submissionStatus[data] === "Rejected";

  const formik = useFormik({
    initialValues: {
      postId: data,
      submitted_by: auth?.username,
      designation: auth?.role,
      relatedOfficeId: auth?.officeId,
      importantNotes: "",
    },

    validationSchema: object().shape({
      postId: number().required("Required"),
      submitted_by: string().required("Required"),
      designation: string().nullable(),
      relatedOfficeId: number().required("Required"),
      importantNotes: string().nullable(),
    }),
    onSubmit: (values) => {
      setLoading(true);
      setError("");

      const formikValues = {
        ...values,
      };

      const submissionAction = isResubmission
        ? axiosPrivate.post(
            `/I-Abide/resubmitDocument`,
            {
              ...formikValues,
              submitter: { id: auth?.uid, userName: auth?.userName },
              file,
            },
            {
              headers: {
                "Content-Type": "multipart/form-data", // Ensure file upload is handled
              },
            }
          )
        : axiosPrivate.post(
            `/I-Abide/submitDocument`,
            {
              ...formikValues,
              submitter: { id: auth?.uid, userName: auth?.userName },
              file,
            },
            {
              headers: {
                "Content-Type": "multipart/form-data", // Set the content type to handle file uploads
              },
            }
          );

      submissionAction
        .then((res) => {
          alert(
            isResubmission
              ? "Successfully resubmitted your document"
              : "Successfully submitted your document"
          );
          onSubmitSuccess();
          formik.resetForm();
          handleClose();
          console.log(res);
        })
        .catch((err) => {
          setError(err?.message);
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  useEffect(() => {
    const areAllValuesFilled = Object.values(formik.values).every(
      (value) => !!value
    );

    setDisabled(areAllValuesFilled);
  }, [formik.values]);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  useEffect(() => {
    formik.setFieldValue("postId", data);
  }, [data]);

  return (
    <Modal
      open={open}
      onClose={() => {
        handleClose();
        // formik.resetForm();
        // setError("");
      }}
    >
      <Box
        variant="form"
        component="form"
        onSubmit={formik.handleSubmit}
        autoComplete="off"
        sx={style}
      >
        <Box
          sx={{
            position: "absolute",
            right: 20,
            cursor: "pointer",
            zIndex: 100,
          }}
        >
          <IconButton onClick={handleClose} sx={{ p: 0 }}>
            <CancelIcon />
          </IconButton>
        </Box>
        <Box>
          <Box
            sx={{
              backgroundColor: "#2a9618",
              borderRadius: "10px",
              width: "50%",
              ml: "3.5%",
              p: 1,
              mb: 1,
            }}
          >
            <Typography
              sx={{ ml: 3.5, fontSize: 18, fontWeight: "bold", color: "#fff" }}
            >
              {isResubmission ? "Resubmitting Form" : "Uploading Form"}
            </Typography>
          </Box>
          {error}
          <Box
            sx={{
              backgroundColor: "rgba(255, 255, 255, 1)",
              boxShadow: "8px 8px 15px 3px rgba(0, 0, 0, 0.3)",
              borderRadius: "10px",
              p: 4,
              mx: 4,
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  id="submitted_by"
                  label="Submitted By"
                  variant="outlined"
                  size="small"
                  disabled={loading || isResubmission}
                  value={formik.values.submitted_by}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBLur}
                  error={
                    formik.touched.submitted_by &&
                    Boolean(formik.errors.submitted_by)
                  }
                  helperText={
                    formik.touched.submitted_by && formik.errors.submitted_by
                  }
                  sx={{ pr: 5 }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id="designation"
                  label="Assigned Role"
                  variant="outlined"
                  size="small"
                  disabled={loading || isResubmission}
                  value={formik.values.designation}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBLur}
                  error={
                    formik.touched.designation &&
                    Boolean(formik.errors.designation)
                  }
                  helperText={
                    formik.touched.designation && formik.errors.designation
                  }
                  sx={{ pr: 5 }}
                  fullWidth
                />
              </Grid>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  gap: 10,
                  p: 2,
                }}
              >
                <input type="file" onChange={handleFileChange} />
              </Box>
              <Grid item xs={12}>
                <TextField
                  id="importantNotes"
                  label="Notes"
                  variant="outlined"
                  size="small"
                  // disabled={loading || isResubmission}
                  value={formik.values.importantNotes}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBLur}
                  error={
                    formik.touched.importantNotes &&
                    Boolean(formik.errors.importantNotes)
                  }
                  helperText={
                    formik.touched.importantNotes &&
                    formik.errors.importantNotes
                  }
                  sx={{ pr: 5 }}
                  fullWidth
                  multiline
                />
              </Grid>
            </Grid>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            p: 2,
            zIndex: 10,
          }}
        >
          <Button
            disabled={!disabled}
            type="submit"
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: disabled ? "blue" : "#c3c3c3",
              color: "#fff",
              py: 1,
              width: "10vw",
              minWidth: "100px",
              "&:hover": {
                border: "solid 1px gray",
                backgroundColor: "lightgray",
                color: "#2b2b2b",
                fontWeight: "bold",
              },
            }}
          >
            <AddIcon
              sx={{
                mr: 1,
                color: "#fff",
              }}
            />
            {isResubmission ? "Resubmit" : "Submit"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
